export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlNHB', function ($controller, $scope) {
    // Extend the base hambs controller
    const hambs = $controller('ComparatorStep3CtrlHAMBS as hambsCtrl', { $scope: $scope });
    angular.extend(this, hambs);
    const ctrl = $scope.$parent.ctrl;

    const setIfHasKeyAndEmpty = (_dest, _source) => {
      const fieldSetPath = _dest.replace(/^dependants\.(\d+)/, 'dependant.');
      const fieldSet = _.get(ctrl.fieldsets, fieldSetPath);
      if (!!fieldSet && _.isEmpty(_.get(ctrl.application, _dest))) {
        _.set(ctrl.application, _dest, _.get(ctrl.application, _source));
      }
    };

    const expandToDependants = (path) => (new Array(ctrl.application.number_of_dependants).fill(0))
        .map((_, index) => `dependants.${index}.${path}`);

    // A list of [changed field name pattern, function to generate target prefills]
    // When an input is blurred, the name of the field that is changing
    // will be matched against the pattern, and if it matches, the function
    // will be called with the regex match, and the resulting field names
    // will be pre-filled with the value coming from the blurred field.
    const preFills = [
      ['personal\\.first_name', () => 'policy.medicare.first_name'],
      ['personal\\.middle_name', () => 'policy.medicare.middle_name'],
      ['personal\\.previous_fund\\.has_previous_fund', () => [
        'partner.previous_fund.has_previous_fund',
      ]],
      ['personal\\.previous_fund\\.fund_id', () => [
        'partner.previous_fund.fund_id',
      ]],
      ['personal\\.previous_fund\\.member_number', () => [
        'partner.previous_fund.member_number',
      ]],
      ['personal\\.previous_fund\\.cover', () => [
        'partner.previous_fund.cover',
      ]],
      ['personal\\.previous_fund\\.date_joined', () => [
        'partner.previous_fund.date_joined',
      ]],
      ['personal\\.previous_fund\\.date_ceased', () => [
        'partner.previous_fund.date_ceased',
      ]],
      ['personal\\.previous_fund\\.transfer_authority', () => [
        'partner.previous_fund.transfer_authority',
      ]],
      ['personal\\.previous_fund\\.cover_to_be_transferred', () => [
        'partner.previous_fund.cover_to_be_transferred',
      ]],
      ['policy\\.medicare\\.number', () => [
        'partner.medicare.number',
        ...expandToDependants('medicare.number'),
      ]],
      ['policy\\.medicare\\.last_name', () => [
        'partner.medicare.last_name',
        ...expandToDependants('medicare.last_name'),
      ]],
      ['policy\\.medicare\\.expiry', () => [
        'partner.medicare.expiry',
        ...expandToDependants('medicare.expiry'),
      ]],
      ['partner\\.first_name', () => 'partner.medicare.first_name'],
      ['partner\\.middle_name', () => 'partner.medicare.middle_name'],
      ['(dependants\\.\\d+)\\.first_name', (match) => `${match[1]}.medicare.first_name`],
      ['(dependants\\.\\d+)\\.middle_name', (match) => `${match[1]}.medicare.middle_name`],
    ];

    this.prefillOnChange = function (key) {
      const scope = this;
      const pathChanged = `${scope.modelPath}.${key}`;

      preFills.forEach(([pattern, handler]) => {
        const match = pathChanged.match(new RegExp(pattern));
        if (match) {
          const destinations = handler(match);
          (Array.isArray(destinations) ? destinations : [destinations]).forEach(
            dest => setIfHasKeyAndEmpty(dest, pathChanged)
          );
        }
      });
    }

    $scope.$watch('ctrl.application.number_of_dependants', () => {
      // Trigger pre-fill on any new dependants that are created
      // This assumes a lot of knowledge about the preFills array.
      preFills.forEach(([pattern, handler]) => {
        const unRegex = pattern.replace(/[\\()]/g, '');
        if (!unRegex.match(/^dependants.*/)) {
          const destinations = handler();
          (Array.isArray(destinations) ? destinations : [destinations]).forEach(
            dest => setIfHasKeyAndEmpty(dest, unRegex)
          );
        }
      })
    });

    // Only show the corporate name question if the applicant's eligibility is
    // Contractor, and selected contractor is Other
    this.showCorporateName = () => {
      // These codes come from the NHB fund handler (EligibilityReason and sub_reasons)
      const EligibilityContractor = 0;
      const EligibilityContractorOther = '005';
      const eligibilityReason = _.get(ctrl.application, 'eligibility_reason');
      const eligibilityDetail = _.get(ctrl.application, 'eligibility_subreason');
      return (
          eligibilityReason === EligibilityContractor &&
          eligibilityDetail === EligibilityContractorOther
      );
    };
  });
}




// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-nhb.js